(function () {
  function readLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  }

  function readSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  }

  function initGiftPopup(root) {
    if (!root || root.dataset.rzGiftInitialized === 'true') return;
    root.dataset.rzGiftInitialized = 'true';

    var backdrop = root.querySelector('[data-rz-gift-backdrop]');
    var panel = root.querySelector('[data-rz-gift-panel]');
    var closeButton = root.querySelector('[data-rz-gift-close]');
    var dismissKey = root.getAttribute('data-rz-gift-storage-key') || 'rz-gift-dismissed-session-v1';
    var claimedKey = 'rz-gift-claimed-v2';
    var autoOpenTimer = null;
    var success = Boolean(root.querySelector('[data-rz-gift-success-state]'));
    var formError = Boolean(root.querySelector('.rz-gift-popup__form .rz-gift-popup__error'));

    if (!backdrop || !panel || !closeButton) return;

    function setHidden(element, hidden) {
      if (hidden) {
        element.setAttribute('hidden', '');
      } else {
        element.removeAttribute('hidden');
      }
    }

    function setState(state) {
      root.setAttribute('data-rz-gift-state', state);
    }

    function openPanel() {
      if (autoOpenTimer) {
        window.clearTimeout(autoOpenTimer);
        autoOpenTimer = null;
      }

      setState('open');
      setHidden(backdrop, false);
      setHidden(panel, false);
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      window.setTimeout(function () {
        var firstField = panel.querySelector('input:not([type="hidden"]), button, a');
        if (firstField) firstField.focus();
      }, 50);
    }

    function closePanel() {
      if (!root.classList.contains('is-open')) return;

      root.classList.remove('is-open');
      setState('dismissed');
      if (!success) writeSessionStorage(dismissKey, 'true');

      window.setTimeout(function () {
        setHidden(backdrop, true);
        setHidden(panel, true);
      }, 250);
    }

    closeButton.addEventListener('click', closePanel);
    backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closePanel();
    });

    var copyButton = root.querySelector('[data-rz-gift-copy]');
    var copyStatus = root.querySelector('[data-rz-gift-copy-status]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = root.querySelector('.rz-gift-popup__code-row code');
        if (!code) return;
        var text = code.textContent.trim();
        var copyPromise = navigator.clipboard && navigator.clipboard.writeText
          ? navigator.clipboard.writeText(text)
          : Promise.reject(new Error('Clipboard unavailable'));
        copyPromise.then(function () {
          if (copyStatus) copyStatus.textContent = 'Copied to your clipboard.';
        }).catch(function () {
          if (copyStatus) copyStatus.textContent = 'Copy this code: ' + text;
        });
      });
    }

    if (success) {
      writeLocalStorage(claimedKey, 'true');
      openPanel();
      return;
    }

    // Returned form errors must remain visible, including on product/cart pages.
    if (formError) {
      openPanel();
      return;
    }

    if (readSessionStorage(dismissKey) === 'true' || readLocalStorage(claimedKey) === 'true') {
      setState('dismissed');
      return;
    }

    // Keep buying pages free of timed signup interruptions. Footer signup stays available.
    var pageType = root.getAttribute('data-rz-page-type');
    if (pageType === 'product' || pageType === 'cart') {
      setState('suppressed-on-purchase-page');
      return;
    }

    setState('pending');
    var pageStartedAt = Number(window.rzGiftPageStartedAt) || Date.now();
    var elapsedSincePageStart = Math.max(0, Date.now() - pageStartedAt);
    var autoOpenDelay = Math.max(0, 15000 - elapsedSincePageStart);
    var smallScreen = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (!smallScreen) {
      autoOpenTimer = window.setTimeout(openPanel, autoOpenDelay);
      return;
    }

    // Small screens: the full-height sheet waits until the visitor has spent 15 seconds
    // on the page and has scrolled at least halfway through it.
    var delayReached = false;
    var scrollReached = false;
    function scrolledHalfway() {
      var doc = document.documentElement;
      var maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
      return (window.scrollY || doc.scrollTop || 0) / maxScroll >= 0.5;
    }
    function openWhenReady() {
      if (!delayReached || !scrollReached) return;
      if (root.getAttribute('data-rz-gift-state') !== 'pending') return;
      window.removeEventListener('scroll', onScroll);
      openPanel();
    }
    function onScroll() {
      if (scrollReached || !scrolledHalfway()) return;
      scrollReached = true;
      openWhenReady();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    autoOpenTimer = window.setTimeout(function () {
      autoOpenTimer = null;
      delayReached = true;
      openWhenReady();
    }, autoOpenDelay);
  }

  function boot() {
    document.querySelectorAll('[data-rz-gift-popup]').forEach(initGiftPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
